import { PortfolioRepo } from "../../portfolio/portfolio.repo";
import { ClientRepo } from "../../clients/client.repo";

class PortfolioTransferController {
  public client: any;
  public portfolio: any;
  selectedItem: any;
  searchText: string;
  public clients: any;
  public oldClient: any;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientRepo: ClientRepo,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any
  ) {}

  $onInit() {
    this.clientRepo
      .getClients(null, null, null, null, null, null, true, null, null)
      .then((results) => {
        const clients = results.data as {
          results: { id: number; name: string; clientNumber: string }[];
        };
        this.clients = clients.results.map((c) => {
          const client = { name: c.name, clientNumber: c.clientNumber };
          return client;
        });
      });
  }

  save() {
    this.clientRepo
      .transferPortfolio(
        this.oldClient.clientNumber,
        this.client.clientNumber,
        this.portfolio.name
      )
      .catch((err) => this.notifyjs(err.data))
      .finally(() => {
        this.$mdDialog.hide();
      });
  }

  clearSearchTerm() {
    this.searchText = "";
  }

  cancel() {
    this.$mdDialog.hide();
  }
}
export const portfolioTransfer: angular.IComponentOptions = {
  template: require("./portfolioTransfer.modal.html"),
  controller: PortfolioTransferController,
  bindings: {
    portfolio: "<",
    oldClient: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/portfolioTransfer.modal.ts